import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import { RiskAssessmentResultControlType } from '@risksmart-app/domain/src/types/consts/risk-assessment-result-control-type';
import type { UpdateControlledRiskInternalAuditResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateControlledRiskInternalAuditResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export type UpdateRiskInternalAuditResultInput = {
  Id: string;
  Rating?: number | null;
  Impact?: number | null;
  Likelihood?: number | null;
  Rationale?: string | null;
  TestDate?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useUpdateControlledRiskInternalAuditResult = createMutationHook({
  name: 'updateControlledRiskInternalAuditResult',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.internalAuditResult.updateRisk.mutationOptions({
      onSuccess,
    }),
  mapInput: (input: UpdateRiskInternalAuditResultInput) => ({
    ...input,
    ControlType: RiskAssessmentResultControlType.Controlled,
  }),
  mapResponse: (): UpdateControlledRiskInternalAuditResultMutation => ({
    update_risk_controlled_internal_audit_result: {
      __typename: 'risk_controlled_internal_audit_result_mutation_response',
      affected_rows: 1,
    },
  }),
  invalidate: (trpc) => [
    trpc.frontend.internalAuditResult.pathKey(),
    trpc.frontend.assessment.internalAuditResultCount.queryKey(),
    // COI-471 parity: Apollo twin also evicts `internal_audit_report`.
    trpc.frontend.internalAuditReport.pathKey(),
  ],
  graphqlDocument: UpdateControlledRiskInternalAuditResultDocument,
  graphqlVariables: (input: UpdateRiskInternalAuditResultInput) => ({
    ...input,
  }),
  evictFields: [
    'risk_controlled_internal_audit_result',
    'internal_audit_report',
    'risk_controlled_internal_audit_result_aggregate',
  ],
});
